// extracted by mini-css-extract-plugin
export var messagingContainer = "styles-module__messagingContainer___ZwROv";